import { Component, OnInit } from '@angular/core';
declare var $:any;


@Component({
  selector: 'app-fc-twothree-twofour',
  templateUrl: './fc-twothree-twofour.component.html',
  styleUrls: ['./fc-twothree-twofour.component.scss']
})
export class FcTwothreeTwofourComponent implements OnInit {
src: string;
isLoading = true;

pdfSrc: string[] = [
  'https://drive.google.com/file/d/1ouPCOtEHrSzRJ5KzWHpgnZc-7418SBS0/preview', // 1 Indian Institute of Comp. Edu
  'https://drive.google.com/file/d/1Bbf9v3t8y306SMTqPtn8HXtj0k3h_baS/preview', // 2 Contrivez
  'https://drive.google.com/file/d/1jytv909lz8n9BMGvYHyurFV5rnasbJKz/preview', // 3 Webcom
  'https://drive.google.com/file/d/1hZTXKfMIFAi1ydsEcJQPgm2iig18XNPU/preview', // 4 Ek Soch Nayi Soch
  'https://drive.google.com/file/d/1Cv1ozGdT767KmFtCKLVjJlJmmvXaW8Ov/preview', // 5 Udhyam Learning + Ek Soch + GNKC
  'https://drive.google.com/file/d/1zltyScuWcYfPArlI5Ljnx44x5OsPB0m8/preview', // 6 SMS Khalsa Lanana Girls College
  'https://drive.google.com/file/d/1nw5oTzuPG6i9gCboY8jLBc2mZAdjMTMc/preview', // 7 GNG College, Yamuna Nagar
  'https://drive.google.com/file/d/1vbqqSyIu5oDu4yTr8hr-YI8Iladj-3sS/preview', // 8 Babu Anant Ram Janta College Kaithal
  'https://drive.google.com/file/d/1uyPTIMRChubDXDTvWn3hE0zNYifm24nn/preview'  // 9 Functional MOU 2023-24
];

ngOnInit(): void {
  this.changeRoute('1');
}

changeRoute(year: string) {
  this.isLoading = true;

  $('.first,.second,.third,.four,.five,.six,.seven,.eight,.nine').removeClass('active');

  if (year=='1') { $('.first').addClass('active'); this.src=this.pdfSrc[0]; }
  if (year=='2') { $('.second').addClass('active'); this.src=this.pdfSrc[1]; }
  if (year=='3') { $('.third').addClass('active'); this.src=this.pdfSrc[2]; }
  if (year=='4') { $('.four').addClass('active'); this.src=this.pdfSrc[3]; }
  if (year=='5') { $('.five').addClass('active'); this.src=this.pdfSrc[4]; }
  if (year=='6') { $('.six').addClass('active'); this.src=this.pdfSrc[5]; }
  if (year=='7') { $('.seven').addClass('active'); this.src=this.pdfSrc[6]; }
  if (year=='8') { $('.eight').addClass('active'); this.src=this.pdfSrc[7]; }
  if (year=='9') { $('.nine').addClass('active'); this.src=this.pdfSrc[8]; }
}

hideLoader() {
  this.isLoading = false;
}
}
